import {ChangeEvent, useCallback, useEffect, useMemo, useState} from 'react';
import {debounce} from 'lodash';

export const useAutoComplete = () => {
  const [inputValue, setInputValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState(inputValue);
  const memoizedFn = useCallback((value: string) => {
    setDebouncedValue(value);
  }, []);

  const debounceSetInputValue = useMemo(
    () => debounce(memoizedFn, 300),
    [memoizedFn],
  );

  useEffect(() => {
    return () => {
      debounceSetInputValue.cancel();
    };
  }, [debounceSetInputValue]);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    setInputValue(value);
    debounceSetInputValue(value);
  };

  const onClear = () => {
    setInputValue('');
    setDebouncedValue('');
  };

  return {
    inputValue,
    debouncedValue,
    onChange,
    onClear,
  };
};
